<template>
  <CustomModal ref="modal" title="Modifier le dossier">
    <div>
      <CustomForm ref="form" :inputs=inputs :submit=buttons.submit>
        <CustomTextField :content=inputs.title />
        <CustomButton @click="submitForm" :params=buttons.submit style="margin-top: 15px" />
      </CustomForm>
    </div>
  </CustomModal>
</template>

<script>
import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
import CustomTextField from "@/components/forms/customs/customTextField/CustomTextField.vue";
import {NotificationService} from "@vues/v-common";
import CustomForm from "@/components/forms/CustomForm.vue";
import CustomModal from "@/components/modals/CustomModal.vue";
import {ProductionController} from "@/controllers/production/ProductionController";

  export default {
      name: 'EditOrderModal',
      props: ['callback'],
      components: {
         CustomModal, CustomForm, CustomTextField, CustomButton},
      data() {
          return {
            order: undefined,
            inputs: {
              title: {label: 'Titre', value: '', type: 'text', required: true},
            },
            buttons:{
              submit: {text: "Valider"},
            },
            isTerminateButtonDisplayed: false
          };
      },
      methods: {
        openModal(order) {
          this.$refs.modal.openModal();
          this.$refs.form?.startLoading();
          this.order = order;
          this.inputs.title.value = order.title;
          this.$refs.form?.stopLoading();
        },
        closeModal() {
          this.$refs.modal?.closeModal();
        },
        terminate(){
          this.closeModal();
          this.callback(true);
        },
        async submitForm() {
          const res = await this.$refs.form.submitForm(() => ProductionController.patch(this.order.id,{
            title: this.inputs.title.value,
          }));
          if (!res.errors) {
            (new NotificationService).addNotification("success", "Dossier modifié");
            this.terminate();
          }
        }
      }
  }

</script>

<style lang="stylus" scoped>
    @require '~/src/common/style/common.styl';
</style>
